module.exports = __webpack_public_path__ + "static/keyboardshortcut-function-do-e2f3845a885d33e6fd6580683a544cab.png";